<template>
  <el-popover
    placement="top"
    width="183"
    v-model="visiable">
    <div class="por confirm-popover-box">
      <i class="el-icon-warning"></i>
      <div class="confirm-popover-text text-danger">{{item.confirm}}</div>
      <div class="text-right">
        <el-button size="mini" type="text" @click="cancel">取消</el-button>
        <el-button type="primary" size="mini" @click="confirm">确定</el-button>
      </div>
    </div>
    <el-button slot="reference"
      v-bind="item.props"
      :type="item.type"
      :disabled="item.disabled"
    >
      {{item.text}}
    </el-button>
  </el-popover>
</template>

<script>
export default {
  name: 'ConfirmButton',
  data () {
    return {
      visiable: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    scope: null
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    cancel ($event) {
      this.visiable = false
      let item = this.item
      item.onCancel && item.onCancel(item, this.scope, $event)
    },
    confirm ($event) {
      this.visiable = false
      let item = this.item
      item.onClick && item.onClick(item, this.scope, $event)
    }
  },
  computed: {
  }
}
</script>
